import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import requiredImage from '../fragments/requiredImage.js';
var schema = defineObject('internationalizedArrayOptionalImageValue', {
    value: {
        title: 'Value',
        type: 'image',
        options: requiredImage.fragment.options
    }
});
var validator = z.object({
    value: requiredImage.validator
}).partial();
schema.internationalizedArrayOptionalImageValue;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayOptionalImageValue.js.map